module.exports = __webpack_public_path__ + "static/media/home_page1.f2031d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_page1.png
// module id = 461
// module chunks = 2